import { getRatesEnterpriseByIdRequest } from "../../data/ratesEnterpriseApi";

function getPayloadData(response) {
  return response?.data?.data || response?.data || null;
}

export async function getTarifaEnterpriseByIdUseCase(id) {
  if (!id) {
    throw new Error("El id de la empresa es obligatorio.");
  }

  return getPayloadData(await getRatesEnterpriseByIdRequest(id));
}
